import { Control } from 'react-hook-form'

import { Box, Collapse, Flex, FormLabel, Text } from '@chakra-ui/react'

import {
  DatePicker,
  DayOfTheWeekPicker,
  FormInputSelectControl,
  FormNumberInputControl,
  RadioButton,
} from '@/components/ui'
import { OptionI } from '@/utils/forms/optionBuilders'

import { DayOptionI } from '../types/types'
import { repeatTypeOptions } from '../utils/utils'
import { LabeledSwitch } from './LabeledSwitch'

export interface RecurrenceToggleIProps {
  control: Control
  endDate?: Date
  isDisabled?: boolean
  selectedStartDate?: Date
  shouldRepeat: boolean
  shouldShowDays?: boolean
  shouldEnd: boolean
  setShouldRepeat?: (value: boolean) => void
  setShouldEnd?: (value: boolean) => void
  onRepeatValueChange?: (valueAsString: string, valueAsNumber: number) => void
  onEndDateChange?: (date: Date) => void
  options?: OptionI[]
  days?: DayOptionI[]
  repeatIntervalNum?: number
  setDays?: (value: string, index: number) => void
}

export const RecurrenceToggle = ({
  days,
  endDate,
  isDisabled,
  setDays,
  control,
  repeatIntervalNum,
  selectedStartDate,
  shouldRepeat,
  shouldShowDays,
  shouldEnd,
  setShouldRepeat,
  onRepeatValueChange,
  onEndDateChange,
  setShouldEnd,
}: RecurrenceToggleIProps) => {
  return (
    <Flex direction='column'>
      <LabeledSwitch
        id='repeats-switch'
        inputRef={null}
        isChecked={shouldRepeat}
        isDisabled={isDisabled}
        label={shouldRepeat ? 'Repeats every' : 'Repeats'}
        onSwitchChange={() => setShouldRepeat(!shouldRepeat)}
      />

      <Collapse in={shouldRepeat}>
        <Flex alignItems='flex-end' flexDirection='row' gap='20px' mb={6}>
          <FormNumberInputControl
            defaultValue={1}
            id='numberOfRepeats'
            isDisabled={isDisabled}
            labelOpacity={1.0}
            min={1}
            onChange={onRepeatValueChange}
            value={repeatIntervalNum}
            width='20%'
          />
          <FormInputSelectControl
            control={control}
            defaultValue={repeatTypeOptions[0]}
            id='repeatType'
            isDisabled={isDisabled}
            labelColour='#1A202C'
            labelOpacity={1.0}
            options={repeatTypeOptions}
            width='30%'
          />
        </Flex>
        <Collapse in={shouldShowDays}>
          <Flex mb={6}>
            <DayOfTheWeekPicker
              days={days}
              isDisabled={isDisabled}
              onClick={setDays}
            />
          </Flex>
        </Collapse>

        <Flex flex={1} flexDirection='column' width='calc(50% + 20px)'>
          <FormLabel mb={2}>Ends</FormLabel>
          <Flex direction='row' py='15px'>
            <Flex flex={1}>
              <RadioButton
                disabled={isDisabled}
                isActive={!shouldEnd}
                label='Never'
                onClick={() => setShouldEnd(false)}
              />
            </Flex>
            <Flex flex={1}>
              <RadioButton
                disabled={isDisabled}
                isActive={shouldEnd}
                label='On Date'
                onClick={() => setShouldEnd(true)}
              />
            </Flex>
          </Flex>
          <Collapse in={shouldEnd}>
            <Box mb={2}>
              <Text fontSize='16px' fontWeight='500' mb='8px'>
                End Date
              </Text>
              <DatePicker
                date={endDate}
                isDisabled={isDisabled}
                minDate={selectedStartDate}
                name='endDate'
                onChange={onEndDateChange}
              />
            </Box>
          </Collapse>
        </Flex>
      </Collapse>
    </Flex>
  )
}
